import React from "react";

const TabButton = ({ selectedTab, handleTabChange, tabName, children }) => {
  const isActive = selectedTab === tabName;
  return (
    <button
      onClick={() => handleTabChange(tabName)}
      className={`font-bold px-2 py-1 mr-2 border-b-2 focus:outline-none transition-colors ${
        isActive
          ? "border-blue-500 text-blue-600"
          : "border-transparent text-gray-600 hover:border-blue-500 hover:text-blue-500"
      }`}
    >
      {children}
    </button>
  );
};

export default TabButton;
